import React, { useMemo } from 'react';

import { FilterTypes } from '@candu-ai/analytics/search';
import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';
import { CollapsableTable } from '@candu-ai/analytics/ui';
import { ACTION_COLUMN } from 'canoe/components/Table/types';
import { getLocalisedNumber } from 'commons/utils';

import { TableFilterActions } from './TableFilterActions';

const getColumns = (title: string) => [
  {
    key: 'host',
    title: 'Host',
    colSpan: 6,
  },
  {
    key: 'count',
    title,
    render: (value: number) => getLocalisedNumber(value, 'en-US'),
  },
  {
    key: 'total',
    title: 'Percentage',
    render: (text: string, record: any) => `${((record.count * 100.0) / record.total).toFixed(1)}%`,
  },
  {
    key: ACTION_COLUMN,
    title: 'actions',
    render: (text: string, record: any) => (
      <TableFilterActions filterType={FilterTypes.Host} value={record.host} />
    ),
  },
];

interface ByViewsProps {
  queryId: QueryId;
  queryParams: QueryParamUrlObject;
  title: string;
}

const ByHostTable = ({ queryId, queryParams, title }: ByViewsProps) => {
  const columns = useMemo(() => getColumns(title), [title]);
  return (
    <CollapsableTable
      label={`${title} by URL Domain`}
      queryId={queryId}
      queryParams={queryParams}
      columns={columns}
    />
  );
};

interface Props {
  queryParams: QueryParamUrlObject;
}

export const ViewsByHostTable = ({ queryParams }: Props) => (
  <ByHostTable queryId={QueryId.ViewsByHostTable} title="Views" queryParams={queryParams} />
);
export const InteractionsByHostTable = ({ queryParams }: Props) => (
  <ByHostTable
    queryId={QueryId.InteractionsByHostTable}
    title="Interactions"
    queryParams={queryParams}
  />
);
